// extracted by mini-css-extract-plugin
export default {"link":"_0aYKV0G1--GetTheAppLink_link__81VD6","wiggle":"_0aYKV0G1--GetTheAppLink_wiggle__aCs9r","shimmer":"_0aYKV0G1--GetTheAppLink_shimmer__A37kh"};